const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
const G = L.map((p) => p.split('').map((b) => (b === '0' ? '1' : '0')).reverse().join(''));
const R = L.map((p) => p.split('').map((b) => (b === '0' ? '1' : '0')).join(''));
const PARITY = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

export function ean13CheckDigit(d12) {
  let s = 0;
  for (let i = 0; i < 12; i++) s += Number(d12[i]) * (i % 2 ? 3 : 1);
  return (10 - (s % 10)) % 10;
}

export function validateEan13(v) {
  if (!/^\d{12,13}$/.test(v)) return 'EAN-13 exige 12 ou 13 dígitos numéricos';
  if (v.length === 13 && ean13CheckDigit(v) !== Number(v[12])) return 'Dígito verificador EAN-13 inválido';
  return null;
}

export function encodeEan13(v) {
  const d = v.length === 12 ? v + ean13CheckDigit(v) : v;
  const par = PARITY[Number(d[0])];
  let out = '101';
  for (let i = 1; i <= 6; i++) out += (par[i - 1] === 'L' ? L : G)[Number(d[i])];
  out += '01010';
  for (let i = 7; i <= 12; i++) out += R[Number(d[i])];
  return `${out}101`;
}

const C128 = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213', '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132', '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211', '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313', '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331', '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111', '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214', '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111', '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141', '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141', '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];

export function validateCode128(v) {
  if (!v.length) return 'Conteúdo vazio';
  if (!/^[\x20-\x7E]+$/.test(v)) return 'Code 128 aceita apenas ASCII imprimível';
  return null;
}

export function encodeCode128B(v) {
  const codes = [104, ...[...v].map((c) => c.charCodeAt(0) - 32)];
  let sum = 104;
  for (let i = 1; i < codes.length; i++) sum += codes[i] * i;
  codes.push(sum % 103, 106);
  let out = '';
  for (const c of codes) {
    const w = C128[c];
    for (let i = 0; i < w.length; i++) out += (i % 2 ? '0' : '1').repeat(Number(w[i]));
  }
  return out;
}
